export enum CalendarGridTimeEventCssVars {
  yPosition = '--y-position',
  height = '--height',
}
